<template>
    <!-- <v-row justify="space-around" no-gutters>
		<v-col cols="auto"> -->
    <v-dialog
        transition="dialog-top-transition"
        max-width="1300"
        v-model="isOpenAditionalStepper"
        persistent
    >
        <v-card class="px-md-1">
            <v-card elevation="0" class="pt-md-2 pl-md-2">
                <h1 class="black--text font-weight-light pb-md-">
                    Añadiendo SVA
                </h1>
                <v-divider></v-divider>
                <v-item-group multiple>
                    <v-container>
                        <v-row
                            class="light"
                            style="height: 550px; overflow-y: scroll"
                        >
                            <v-col
                                v-for="(sva, index) in availableSVAS"
                                :key="sva.id"
                                md="4"
                                cols="12"
                            >
                                <v-item v-slot="{}">
                                    <div>
                                        <v-card
                                            style="border-radius: 10px 10px 0px 0px !important;""
                                            :color="
                                                checkSelectedSVA(sva)
                                                    ? 'yellow darken-2'
                                                    : 'primary darken-1'
                                            "
                                            :class="
                                                index < 3
                                                    ? 'd-flex flex-column pa-4 mt-7'
                                                    : 'd-flex flex-column pa-4'
                                            "
                                            dark
                                            height="220"
                                            max-width="100%"
                                            @click="changeSVA(sva)"
                                            elevation="0"
                                        >
                                            <!-- <div class="'d-flex align-center"> -->
                                            <v-btn
                                                fab
                                                color="red"
                                                absolute
                                                top
                                                right
                                                v-if="
                                                    mainLine.tarifa &&
                                                    index < activeAvailableSva
                                                "
                                                x-large
                                            >
                                                <div class="d-flex flex-column">
                                                    <v-icon
                                                        size="34"
                                                        class="pl-8"
                                                        >mdi-toy-brick-plus-outline</v-icon
                                                    >
                                                    <small class="overline"
                                                        ><small
                                                            ><small
                                                                >Compatible</small
                                                            ></small
                                                        ></small
                                                    >
                                                </div>
                                            </v-btn>
                                            <div
                                                class="
                                                    flex-grow-1
                                                    text-center
                                                    flex-row
                                                "
                                            >
                                                <v-icon
                                                    size="60"
                                                    :color="
                                                        checkSelectedSVA(sva)
                                                            ? 'black'
                                                            : 'white'
                                                    "
                                                >
                                                    {{
                                                        computedSVAIcon(
                                                            sva.name
                                                        )
                                                    }}
                                                </v-icon>
                                                <h1
                                                    :class="
                                                        checkSelectedSVA(sva)
                                                            ? 'black--text font-weight-light'
                                                            : 'white--text font-weight-light'
                                                    "
                                                >
                                                    {{ sva.name }}
                                                </h1>
                                                <v-chip
                                                    :color="
                                                        !checkSelectedSVA(sva)
                                                            ? 'yellow darken-2'
                                                            : 'black'
                                                    "
                                                    outlined
                                                >
                                                    <v-icon> mdi-cash </v-icon>
                                                    <h4 color="white">
                                                        {{
                                                            sva.price
                                                                ? (
                                                                      sva.price *
                                                                      iva
                                                                  ).toFixed(2)
                                                                : 'consultar'
                                                        }}
                                                        €
                                                    </h4>
                                                </v-chip>
                                            </div>
                                            <!-- </div> -->
                                        </v-card>
                                        <v-card
                                            style="border-radius: 0px 0px 10px 10px !important;height: 200px;overflow-y: scroll;"
                                            max-width="100%"
                                            :color="
                                                checkSelectedSVA(sva)
                                                    ? 'yellow darken-2'
                                                    : 'primary darken-1'
                                            "
                                            class="d-flex flex-column pa-md-4"
                                        >
                                            <v-row class="px-1">
                                                <v-col cols="5">
                                                    <h4
                                                        :class="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black--text font-weight-light'
                                                                : 'white--text font-weight-light'
                                                        "
                                                    >
                                                        Promociones Disponibles
                                                    </h4>
                                                </v-col>
                                                <v-col
                                                    cols="1"
                                                    class="d-flex justify-end"
                                                >
                                                    <v-icon
                                                        :color="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black'
                                                                : 'white'
                                                        "
                                                        >mdi-arrow-down</v-icon
                                                    >
                                                </v-col>
                                                <v-col cols="5">
                                                    <h4
                                                        :class="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black--text font-weight-light'
                                                                : 'white--text font-weight-light'
                                                        "
                                                    >
                                                        Número Seleccionados
                                                    </h4>
                                                </v-col>
                                                <v-col
                                                    cols="1"
                                                    class="d-flex justify-end"
                                                >
                                                    <v-icon
                                                        :color="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black'
                                                                : 'white'
                                                        "
                                                        >mdi-arrow-down</v-icon
                                                    >
                                                </v-col>
                                            </v-row>
                                            <v-row class="mt-n2 mb-n6">
                                                <v-col cols="6" class="px-3">
                                                    <v-divider
                                                        :color="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black'
                                                                : 'white'
                                                        "
                                                    ></v-divider>
                                                </v-col>
                                                <v-col cols="6" class="px-3">
                                                    <v-divider
                                                        :color="
                                                            checkSelectedSVA(
                                                                sva
                                                            )
                                                                ? 'black'
                                                                : 'white'
                                                        "
                                                    ></v-divider>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col
                                                    v-if="
                                                        sva.promotions.length ==
                                                        0
                                                    "
                                                    cols="6"
                                                    class="
                                                        d-flex
                                                        justify-center
                                                    "
                                                >
                                                    <v-row>
                                                        <v-col cols="4">
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                dark
                                                                small
                                                                color="transparent"
                                                                class="pa-3"
                                                            >
                                                                <v-icon
                                                                    color="white"
                                                                >
                                                                    mdi-minus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-badge
                                                                overlap
                                                                icon="mdi-lock"
                                                            >
                                                                <v-btn
                                                                    fab
                                                                    dark
                                                                    small
                                                                    depressed
                                                                    color="transparent"
                                                                    class="pa-3"
                                                                >
                                                                    <v-icon
                                                                        color="white"
                                                                    >
                                                                        mdi-sale
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-badge>
                                                        </v-col>
                                                        <v-col cols="4">
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                dark
                                                                small
                                                                color="transparent"
                                                                class="pa-3"
                                                            >
                                                                <v-icon
                                                                    color="white"
                                                                >
                                                                    mdi-plus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6" v-else>
                                                    <v-row
                                                        v-for="(
                                                            promo, promoIndex
                                                        ) in SVAPromos(sva)"
                                                        :key="promoIndex"
                                                        class="px-3"
                                                        v-if="promo && promo.is_active"
                                                    >
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                small
                                                                @click="
                                                                    changeSelectedNumberPromo(
                                                                        promo,
                                                                        sva,
                                                                        'minus'
                                                                    )
                                                                "
                                                                color="transparent"
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        checkSelectedSVA(
                                                                            sva
                                                                        )
                                                                            ? 'black'
                                                                            : 'white'
                                                                    "
                                                                >
                                                                    mdi-minus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <v-tooltip
                                                                left
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-badge
                                                                        overlap
                                                                        :color="
                                                                            checkSelectedPromo(
                                                                                promo
                                                                            )
                                                                                ? 'green darken-3'
                                                                                : 'red darken-3'
                                                                        "
                                                                        :content="
                                                                            promoCounter(
                                                                                promo.id
                                                                            ) ==
                                                                            0
                                                                                ? '0'
                                                                                : promoCounter(
                                                                                      promo.id
                                                                                  )
                                                                        "
                                                                    >
                                                                        <v-btn
                                                                            small
                                                                            fab
                                                                            depressed
                                                                            class="
                                                                                pa-3
                                                                            "
                                                                            :color="
                                                                                checkSelectedPromo(
                                                                                    promo
                                                                                )
                                                                                    ? 'green darken-3'
                                                                                    : 'red darken-3'
                                                                            "
                                                                            @click="
                                                                                changeSVAPromo(
                                                                                    promo,
                                                                                    sva
                                                                                )
                                                                            "
                                                                            v-bind="
                                                                                attrs
                                                                            "
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        >
                                                                            <v-icon
                                                                                color="white"
                                                                            >
                                                                                mdi-sale
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </v-badge>
                                                                </template>
                                                                <span>{{promoText(promo)}}</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                small
                                                                @click="
                                                                    changeSelectedNumberPromo(
                                                                        promo,
                                                                        sva,
                                                                        'plus'
                                                                    )
                                                                "
                                                                color="transparent"
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        checkSelectedSVA(
                                                                            sva
                                                                        )
                                                                            ? 'black'
                                                                            : 'white'
                                                                    "
                                                                >
                                                                    mdi-plus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-row class="px-3">
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                small
                                                                @click="
                                                                    changeSelectedNumberSVA(
                                                                        sva,
                                                                        'minus'
                                                                    )
                                                                "
                                                                color="transparent"
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        checkSelectedSVA(
                                                                            sva
                                                                        )
                                                                            ? 'black'
                                                                            : 'white'
                                                                    "
                                                                >
                                                                    mdi-minus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <h2
                                                                :class="
                                                                    checkSelectedSVA(
                                                                        sva
                                                                    )
                                                                        ? 'black--text display-1 font-weight-light'
                                                                        : 'white--text display-1 font-weight-light'
                                                                "
                                                            >
                                                                {{
                                                                    selectedSVA.filter(
                                                                        (
                                                                            another
                                                                        ) =>
                                                                            another.id ==
                                                                            sva.id
                                                                    ).length
                                                                }}
                                                            </h2>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="
                                                                d-flex
                                                                justify-center
                                                                pa-3
                                                            "
                                                        >
                                                            <v-btn
                                                                depressed
                                                                fab
                                                                small
                                                                @click="
                                                                    changeSelectedNumberSVA(
                                                                        sva,
                                                                        'plus'
                                                                    )
                                                                "
                                                                color="transparent"
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        checkSelectedSVA(
                                                                            sva
                                                                        )
                                                                            ? 'black'
                                                                            : 'white'
                                                                    "
                                                                >
                                                                    mdi-plus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </div>
                                </v-item>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-item-group>
            </v-card>
            <v-card-actions class="justify-end">
                <v-btn color="primary" depressed @click="submitSVA()"> Guardar </v-btn>

                <v-btn text color="red" @click="closeAditionalStepper()">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapGetters, createLogger } from 'vuex';
import { VTooltip } from 'vuetify';
import { clone } from '@/util/libUtil.js';

export default {
    name: 'ConfiguratorAditional',

    data: () => ({
        selectedSVA: [],
        selectedPromos: [],
        currentSelectedOperator: null,
        activeAvailableSva: 0,
    }),
    components: {
        VTooltip,
    },
    methods: {
        SVAPromos(sva){
            let promos = []
            sva.promotions.forEach(promo => {
                let found = this.promotions.find(anotherPromo => anotherPromo.id == promo)
                if (found) promos.push(found)
            })
            return promos
        },
        checkSelectedSVA(sva) {
            return this.selectedSVA.some((another) => sva.id == another.id);
        },
        checkSelectedPromo(promo) {
            return this.selectedPromos.some(
                (another) => promo.id == another.id
            );
        },
        changeSelectedNumberSVA(sva, action) {
            switch (action) {
                case 'plus':
                    this.selectedSVA.push(sva);
                    break;
                case 'minus':
                    let index = this.selectedSVA.indexOf(sva);
                    if (index != -1) this.selectedSVA.splice(index, 1);

                    if (sva.promotions.length > 0) {
                        this.SVAPromos(sva).forEach((promo) => {
                            if (
                                this.selectedPromos.some(
                                    (promotion) => promo == promotion
                                )
                            ) {
                                let index = this.selectedPromos.indexOf(promo);
                                if (index != -1)
                                    this.selectedPromos.splice(index, 1);
                            }
                        });
                    }
                    break;
            }
        },
        changeSelectedNumberPromo(promo, sva, action) {
            switch (action) {
                case 'plus':
                    if (
                        this.selectedSVA.filter(
                            (another) => sva.id == another.id
                        ).length >
                        this.selectedPromos.filter(
                            (another) => promo.id == another.id
                        ).length
                    )
                        this.selectedPromos.push(promo);
                    break;
                case 'minus':
                    let index = this.selectedPromos.indexOf(promo);
                    if (index != -1) this.selectedPromos.splice(index, 1);
                    break;
            }
        },
        changeSVAPromo(promo, sva) {
            if (!this.checkSelectedSVA(sva)) this.selectedSVA.push(sva);

            if (!this.selectedPromos.includes(promo))
                this.selectedPromos.push(promo);
            else
                this.selectedPromos = this.selectedPromos.filter(
                    (another) => promo.id != another
                );
        },
        changeSVA(sva) {
            if (!this.checkSelectedSVA(sva)) this.selectedSVA.push(sva);
            else
                this.selectedSVA = this.selectedSVA.filter(
                    (another) => sva.id != another.id
                );

            if (sva.promotions.length > 0) {
                sva.promotions.forEach((promo) => {
                    this.selectedPromos = this.selectedPromos.filter(
                        (another) => promo != another.id
                    );
                });
            }
        },
        closeAditionalStepper() {
            this.$store.commit(
                'configuradorOferta/isOpenAditionalStepper',
                false
            );
        },
        clearFields() {
            if (this.principal) {
                this.$store.state.configuradorOferta.paquetes =
                    this.$store.state.configuradorOferta.atencion.oferta.paquetes.filter(
                        (paquete) => paquete.tipoLinea != 'LINEA_ADICIONAL_SVA'
                    );
            }
        },
        submitSVA() {
            // this.principal.svas = this.selectedSVA
            // this.principal.promotion = this.selectedPromos
            this.clearFields();

            // this.paquetesSVA.forEach((paquete) => {
            // 	let auxPaquete = this.paquetes.find((another) => paquete == another)
            // 	let index = this.paquetes.indexOf(auxPaquete)
            // 	if(index =! -1) this.paquetes.splice(index, 1)
            // })

            let auxPromos = clone(this.selectedPromos);
            console.log(this.selectedSVA)
            this.selectedSVA.forEach((sva) => {
                let paquete = clone(this.paquete);
                paquete.tipoLinea = 'LINEA_ADICIONAL_SVA';
                paquete.tarifa = sva;
                paquete.lineasAsociadas = clone(this.principal.lineasAsociadas);

                let matches = auxPromos.filter((promo) =>
                    sva.promotions.some((another) => promo.id == another)
                );

                // Eliminamos promociones repetidas
                matches.forEach((element) => {
                    if (
                        !paquete.promotion.some(
                            (promo) => element.id == promo.id
                        )
                    ) {
                        paquete.promotion.push(element);
                    }
                });

                // Eliminar promo si la hemos aplicado
                if (paquete.promotion)
                    paquete.promotion.forEach((promo) => {
                        let index = auxPromos.indexOf(promo);
                        if (index != -1) auxPromos.splice(index, 1);
                    });

                this.$store.commit('configuradorOferta/package', paquete);
            });

            this.closeAditionalStepper();
        },
        computedSVAIcon(svaName) {
            if (svaName.toLowerCase().includes('tv')) return 'mdi-television';
            else if (
                svaName.toLowerCase().includes('seguridad') ||
                svaName.toLowerCase().includes('kit')
            )
                return 'mdi-cctv';
            else if (svaName.toLowerCase().includes('ip'))
                return 'mdi-ip-network';
            else if (svaName.toLowerCase().includes('energ'))
                return 'mdi-lightbulb-group-outline';
            else if (svaName.toLowerCase().includes('doctor'))
                return 'mdi-doctor';
            else if (svaName.toLowerCase().includes('fax'))
                return 'mdi-email-send-outline';
            else if (svaName.toLowerCase().includes('office'))
                return 'mdi-microsoft-office';
            else return 'mdi-basket-plus-outline';
        },
        promoCounter(promoId) {
            return this.selectedPromos.filter(
                (another) => another.id == promoId
            ).length;
        },
        setSVAPackages() {
            this.selectedSVA = [];
            this.selectedPromos = [];

            let auxSVA = [];
            this.paquetesSVA.forEach((paquete) => {
                let sva = this.availableSVAS.find(
                    (sva) => sva.id == paquete.tarifa.id
                );
                this.selectedSVA.push(sva);

                paquete.promotion.forEach((promo) => {
                    let promotion = sva.promotions.find(
                        (another) => another == promo.id
                    );
                    this.selectedPromos.push(promotion);
                });
            });
        },
        promoText(promo){
            return promo.name ? `${promo.name} ➜ ${promo.amount} ${promo.amount_unit == 'MONETARY' ? '€' : '%'}` : 'Sin Nombre'
        },
    },
    computed: {
        isOpenAditionalStepper: {
            get() {
                return this.$store.state.configuradorOferta
                    .isOpenAditionalStepper;
            },
            set(val) {
                this.$store.commit(
                    'configuradorOferta/isOpenAditionalStepper',
                    val
                );
            },
        },
        availableSVAS() {
            let copy = [];
            this.activeAvailableSva = 0;

            this.svas.forEach((sva) => {
                if (this.$store.state.configuradorOferta.isp) {
                    if (
                        sva.operator ==
                            this.$store.state.configuradorOferta.isp.isp &&
                        (sva.segment ==
                            this.$store.state.configuradorOferta.isp.segment ||
                            sva.segment == 'TODOS')
                    ) {
                        copy.push(sva);
                    }
                }
            });

            if (
                (this.mainLine.tarifa &&
                        !this.mainLine.tarifa.max_number &&
                        this.mainLine.tarifa.svas)
            ) {
                let active = [];
                this.mainLine.tarifa.svas.forEach((sva) => {
                    if (sva.is_active == true) active.push(sva);
                });

                this.mainLine.tarifa.svas.forEach((compatible) => {
                    let found = copy.find(
                        (findSVA) => compatible.id == findSVA.id
                    );
                    let index = copy.indexOf(found);

                    if (index != -1) copy.splice(index, 1);
                });
                this.activeAvailableSva = active.length;

                return [...active, ...copy];
            } else {
                return copy;
            }
        },
        ...mapState('configuradorOferta', {
            isp: (state) => state.isp,
            paquete: (state) => state.paquete,
            svas: (state) => state.svas,
            promotions: (state) => state.promotions,
            paquetes: (state) => state.atencion.oferta.paquetes,
            atencion: (state) => state.atencion,
            configuratorType: (state) => state.configuratorType,
            principal: (state) =>
                state.atencion.oferta.paquetes.find(
                    ({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL'
                ),
            paquetesSVA: (state) =>
                state.atencion.oferta.paquetes.filter(
                    (paquete) => paquete.tipoLinea == 'LINEA_ADICIONAL_SVA'
                ),
        }),
        ...mapGetters('configuradorOferta', {}),
        ...mapGetters('configuradorOferta', ['mainLine', 'iva']),
    },
    created() {
        if (this.svas.length < 1) {
            this.$store.dispatch('configuradorOferta/getSVA');
        }
    },
    updated() {
        if (
            this.currentSelectedOperator != this.isp &&
            this.configuratorType != 'EDIT'
        )
            this.clearFields();
        else if (this.principal) {
            // this.selectedSVA = this.principal.svas
            // this.selectedPromos = this.principal.promotion
        }

        if (this.isp) {
            this.currentSelectedOperator = this.isp;
        }
    },
    watch: {
        isOpenAditionalStepper(val) {
            if (val)
                try {
                    this.setSVAPackages();
                } catch {}
        },
    },
};
</script>

<style>
.transparent {
    background-color: transparent !important;
}
.light::-webkit-scrollbar {
    width: 7px;
}

.light::-webkit-scrollbar-track {
    background: #ffffff;
    border-left: 0px solid #ffffff;
}

.light::-webkit-scrollbar-thumb {
    background: #00205a;
    border: solid 0px #e6e6e6;
    border-radius: 7px;
}

.light::-webkit-scrollbar-thumb:hover {
    background: rgb(185, 0, 0);
}
</style>